
import BaseGeoCell from "@/components/BaseGeoCell";
import BaseGeoTable from "@/components/BaseGeoTable";
import BaseFooter from "@/components/BaseFooter";

export default [
    BaseGeoCell,
    BaseGeoTable,
    BaseFooter,

];
